import {AsyncPipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {Router, RouterLink} from '@angular/router'
import {getTakeUntilDestroyed, LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {CUSTOMERS_ROUTE_PATH, HOME_ROUTE_PATH} from '../../application/data-types'
import {ControlService} from '../../services/control.service'
import {DataService} from '../../services/data.service'
import {KalpService, Scenarios} from '../../services/kalp.service'
import {TestService} from '../../services/test.service'
import {TestComponent} from '../test/test.component'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {MatIcon} from '@angular/material/icon'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    MatButton,
    TestComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    AsyncPipe,
    LogoComponent,
    MatIconButton,
    MatIcon,
    ToggleButtonComponent
  ]
})
export class HeaderComponent implements OnInit {
  public configService = inject(ConfigService)
  public controlService = inject(ControlService)
  public dataService = inject(DataService)
  public testService = inject(TestService)

  public mainPath = '/' + HOME_ROUTE_PATH
  public customerPath = '/' + CUSTOMERS_ROUTE_PATH

  public scenario: Scenarios | null = null

  private readonly kalpService = inject(KalpService)
  private readonly router = inject(Router)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.kalpService.scenarioChange$
      .pipe(this.takeUntilDestroyed())
      .subscribe((scenario: Scenarios | null) => this.scenario = scenario)
  }

  public reset(): void {
    this.dataService.reset()
    this.router.navigate(['/', HOME_ROUTE_PATH]).then()
  }
}
